import styled from 'styled-components';
import { THEME } from '../../../themes';
import {
  Body1Font, Body2Font, OverlineFont, Title2Font, Title3Font,
} from '../../../themes/fonts';
import Dialog from '../base-dialog/base-dialog.component';
import BaseSelectionGroup from '../../Common/base-selection-group/base-selection-group.component';
import SelectionGroupItem from '../../Common/base-selection-group/selection-group-item/selection-group-item.component';
import { hexToRgbA } from '../../../utils/colors';

export const StyledBody = styled(Dialog.Body)`
  padding: 0;
  align-self: center;
  width: 1400px;
`;

export const Container = styled.div`
  display: flex;
  gap: ${THEME.SPACING.LOOSE};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${THEME.SPACING.LOOSE};
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${THEME.SPACING.BASE};
  align-items: center;
  justify-content: center;
`;

export const AvailablePlansWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${THEME.SPACING.MEDIUM};
`;

export const Subtitle = styled.div`
  ${Title3Font};
  color: ${THEME.COLORS.CONTENT_A};
`;

export const Title = styled.div`
  ${Title2Font};
  font-weight: 600;
  color: ${THEME.COLORS.CONTENT_A};
`;

export const Description = styled.div`
  ${Body1Font};
  opacity: ${THEME.OPACITY.MED};
  color: ${THEME.COLORS.CONTENT_A};
  text-align: center;
  line-height: 1.5;
  white-space: pre-line;
  max-width: 700px;
`;

export const Perks = styled.h6`
  ${Body2Font};
`;

export const YearlyWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${THEME.SPACING.TINY};
`;

export const YearlyDiscount = styled.div`
  height: 22px;
  border-radius: ${THEME.RADIUS.ROUNDISH};
  background-color: ${hexToRgbA(THEME.COLORS.SUCCESS, THEME.OPACITY.GHOST)};
  color: ${THEME.COLORS.SUCCESS};
  text-align: center;
  padding: ${THEME.SPACING.TINY};
  ${OverlineFont};
  font-weight: bold;
  display: flex;
  align-items: center;
`;

export const BillingPeriodSelect = styled(BaseSelectionGroup)``;

export const BillingPeriodOption = styled(SelectionGroupItem)`
  width: auto;
  padding: ${THEME.SPACING.MICRO} ${THEME.SPACING.TINO};
`;
